import { YNReturn, TrueFalseReturn } from './Booleans.js';

export default [
	{ 'name': 'YNReturn', 'action': YNReturn },
	{ 'name': 'TrueFalseReturn', 'action': TrueFalseReturn }
];
